module.exports = __webpack_public_path__ + "img/@logo_seavantage@3x.83d27f5f.png";